import { render, staticRenderFns } from "./ScoreboardWalletSupplier.vue?vue&type=template&id=d7996c0e&scoped=true&"
import script from "./ScoreboardWalletSupplier.vue?vue&type=script&lang=js&"
export * from "./ScoreboardWalletSupplier.vue?vue&type=script&lang=js&"
import style0 from "./ScoreboardWalletSupplier.vue?vue&type=style&index=0&id=d7996c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7996c0e",
  null
  
)

export default component.exports